import InfoBlock from "./InfoBlock"
export default InfoBlock
